import { CircularProgress, Grid, LinearProgress } from "@material-ui/core";
import { lightOrange } from "./theme";
import { requestActivity } from "./";
import React from "react";

export function Spinner({ complete, children }) {
  return complete ? (
    children
  ) : (
    <Grid
      container
      direction="column"
      style={{ width: "100%", height: "100vh" }}
      justify="center"
      alignItems="center"
    >
      <Grid item>
        <CircularProgress />
      </Grid>
    </Grid>
  );
}

export function RequestActivity() {
  const active = requestActivity((s) => s.active);
  const style: any = {
    position: "absolute",
    width: "100%",
    zIndex: 1501,
  };
  return (
    <div style={style}>
      {active && (
        <LinearProgress
          id="progress-bar"
          style={{
            backgroundColor: lightOrange,
            top: 0,
          }}
        />
      )}
    </div>
  );
}
